

export type BoundingSphere = {
  center: Float32Array; // vec3
  radius: number;
};


export function createBoundingSphere(
  x = 0, y = 0, z = 0,
  radius = 0
): BoundingSphere {
  return {
    center: new Float32Array([x, y, z]),
    radius,
  };
}

export function cloneBoundingSphere(src: BoundingSphere): BoundingSphere {
  return {
    center: new Float32Array(src.center),
    radius: src.radius,
  };
}
export function spheresOverlap(
  centerA: Float32Array,
  radiusA: number,
  centerB: Float32Array,
  radiusB: number
): boolean {
  const dx = centerA[0] - centerB[0];
  const dy = centerA[1] - centerB[1];
  const dz = centerA[2] - centerB[2];

  const distanceSq = dx * dx + dy * dy + dz * dz;
  const radiusSum = radiusA + radiusB;

  return distanceSq <= radiusSum * radiusSum;
}

export function sphereOverlaps(a: BoundingSphere, b: BoundingSphere): boolean {
  const dx = a.center[0] - b.center[0];
  const dy = a.center[1] - b.center[1];
  const dz = a.center[2] - b.center[2];

  const distanceSq = dx * dx + dy * dy + dz * dz;
  const radiusSum = a.radius + b.radius;

  return distanceSq <= radiusSum * radiusSum;
}

export function sphereContainsPoint(
  sphere: BoundingSphere,
  point: Float32Array
): boolean {
  const dx = point[0] - sphere.center[0];
  const dy = point[1] - sphere.center[1];
  const dz = point[2] - sphere.center[2];
  return dx * dx + dy * dy + dz * dz <= sphere.radius * sphere.radius;
}
